import './LoadingPlaceholder.css'
import {ListEntrySquished} from "../Elements/ListEntry";
import {useEffect, useState} from "react";
import React from 'react';
import {List} from "../Elements/List";
import {blackCircle} from "../Icons/Icons";

export function Loading({className} : {className : string}) {
    return <div className={`l-rounded loading-placeholder ${className} loading-animated-background-bright`}/>
}

export function LoadingCenter({className} : {className : string}) {
    return <div className="loading-center">
        <Loading className={className}/>
    </div>
}


const circleBig =  <div style={{width: "2rem"}}>
    <svg className="spinning" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10" stroke="white"
              strokeWidth="3" strokeLinecap="round"/>
    </svg>
</div>

export function LoadingCircle({className} : {className : string}) {
    return <div className={className}> {circleBig} </div>;
}

export function LoadingCircleBlack({className} : {className : string}) {
    return <div className={className}> {blackCircle} </div>;
}

export function LoadingListEntrySquished() {
    const [textLength, setTextLength] = useState(70)
    const [subscriptLength, setSubscriptLength] = useState(30)
    const [rightTextLength, setRightTextLength] = useState(10)

    useEffect(() => {
        setTextLength(Math.random() * 80 + 80)
        setSubscriptLength(Math.random() * 20 + 30)
        setRightTextLength(Math.random() * 10 + 50)
    }, []);

    const image = <div className="flex-center">
        <div className="circle-image loading-animated-background-bright" style={{backgroundColor: "#303030"}}/>
    </div>

    const text = <div style={{width: textLength}}>
        <Loading className="micro-margin-all loading-entry-text"/>
    </div>

    const subscript = <div style={{width: subscriptLength}}>
        <Loading className="micro-margin-all loading-entry-subscript"/>
    </div>

    const rightText = <div style={{width: rightTextLength}}>
        <Loading className="small-margin-right loading-entry-text"/>
    </div>

    return <div className="small-margin entry-light-bg"> <ListEntrySquished
        imageElement={image}
        title={text}
        rightText={rightText}
        subscript={subscript}
    /> </div>
}

export function LoadingList({count, height} : {count : number, height: string}){
    return <div style={{height: height}}> <List
        createElement={_ => <LoadingListEntrySquished/>}
        collection={Array(count).fill(0)}
        elementHeight={70}
        id={"loading-list"}
    /></div>;
}

export function LoadingButton(){
    return <Loading className={"button-outer"}/>
}

export function LoadingSubscript(){
    return <div className="full-size flex-center">
        <Loading className={"l-rounded l-margin loading-button-subscript"}/>
    </div>
}

export function LoadingVariableLength({min, max, className} : {min: number, max: number, className: string}) {
    const [textLength, setTextLength] = useState(70);

    useEffect(() => {
        setTextLength(Math.random() * (max - min) + min)
    }, [max, min]);

    return <div style={{width: textLength, maxWidth: "100%"}}>
        <Loading className={className}/>
    </div>
}